var path = '/components/directives/customfield/integer.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">{{field.definition.name}}\n    <span ng-if=\"field.definition.required\">*</span>\n    <i class=\"fal fa-info-circle\" ng-if=\"field.definition.tooltip\">\n        <span data-tooltip=\"{{::field.definition.tooltip}}\"></span>\n    </i>\n</label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{field.definition.help}}</p>\n<input type=\"number\" id=\"{{name}}\" step=\"1\" ng-model=\"field.ngModel\" name=\"{{name}}\" ng-disabled=\"!field.lodash.isUndefined(field.definition.disabled) && field.definition.disabled\"/>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/integer.tpl.html
// module id = 1993
// module chunks = 1